export default {
  Training: {
    BtnRegister: 'Đăng ký tham gia',
    Registered: 'Đã đăng ký',
    RecommendTrainingContent: 'Đề xuất nội dung tập huấn',
    RecommendNoTrainingDescription: 'Hiện tại không có khóa Tập huấn nào sắp diễn ra, Thầy/Cô có thể đề xuất nội dung tập huấn mình quan tâm tại đây.',
    RecommendTrainingDescription: 'Nếu không tìm được khóa Tập huấn phù hợp, Thầy/Cô có thể đề xuất nội dung tập huấn mình quan tâm tại đây.',
    JoinTraining: 'Tham gia tập huấn',
    JoinTrainingDescription: 'Nhằm hỗ trợ Thầy/Cô thấu hiểu nghiệp vụ và sử dụng phần mềm thành thạo, hiệu quả.',
    Problem: 'Vấn đề thường gặp',
    WatchMore: 'Xem thêm',
    FacebookCommunity: 'Cộng đồng Facebook hỗ trợ',
    FacebookCommunityDescription: 'Nơi trao đổi, chia sẻ kinh nghiệm sử dụng phần mềm và  giải đáp thắc mắc từ nhân viên hỗ trợ MISA.',
    FacebookGroup: 'https://www.facebook.com/groups/hotroqlth/',
    FrequentlyAskedQuestion: 'https://emishelp.misa.vn/ac/on_tap/',
    Name: 'Họ và tên (bắt buộc)',
    Email: 'Email',
    PhoneNumber: 'Số điện thoại (bắt buộc)',
    RecommendContent: 'Nội dung đề xuất  (bắt buộc)',
    SendRecommendation: 'Gửi đề xuất',
    SendRecommendationSuccess: 'Gửi đề xuất thành công!',
    SendAnotherRecommendation: 'Gửi đề xuất khác',
    TrainingTime: 'Từ {startDate} đến {endDate}'
  }
}
